import {
  getUnit,
  floorByUnit,
} from 'components/features/new-report/utils/constructor';
import { commaFormat } from 'components/features/new-report/utils/formatter';
import React from 'react';

type Props = {
  imgPath: string;
  title: string;
  onClick: () => void;
  subInformation:
    | {
        tag: 'recommendsAndSubInformation';
        recommendAccounts: string[];
        roughTargetAmount: number;
        description: string;
        isRecommendMark: boolean;
      }
    | {
        tag: 'subInformationOnly';
        roughTargetAmount: number;
        description: string;
      }
    | {
        tag: 'nothing';
      };
};

const RecommendAccountTag = ({
  title,
  className,
}: {
  title: string;
  className?: string;
}): React.ReactElement => {
  return (
    <>
      <div
        className={`rounded bg-teal-50 text-teal-700 px-2 text-xs ${className ??
          ''}`}>
        {title}
      </div>
    </>
  );
};

export const TargetTypeCard = ({
  imgPath,
  onClick,
  subInformation,
  title,
}: Props): React.ReactElement => {
  const {
    description,
    recommendAccounts,
    roughTargetAmount,
    isRecommendMark,
  } = ((): Partial<{
    recommendAccounts: string[];
    roughTargetAmount: number;
    description: string;
    isRecommendMark: boolean;
  }> => {
    switch (subInformation.tag) {
      case 'nothing':
        return {};
      case 'recommendsAndSubInformation':
        return {
          description: subInformation.description,
          roughTargetAmount: subInformation.roughTargetAmount,
          recommendAccounts: subInformation.recommendAccounts,
          isRecommendMark: subInformation.isRecommendMark,
        };
      case 'subInformationOnly':
        return {
          description: subInformation.description,
          roughTargetAmount: subInformation.roughTargetAmount,
        };
    }
  })();
  return (
    <>
      <div
        className={`rounded-lg overflow-hidden grid w-full shadow cursor-pointer`}
        style={{ gridTemplateColumns: '1fr auto' }}
        onClick={onClick}>
        <div className={`bg-white`}>
          <div className={`grid`} style={{ gridTemplateColumns: 'auto 1fr' }}>
            <img
              src={imgPath}
              alt="目標のイメージ"
              className={` w-20`}
              style={{ objectFit: 'cover', height: '73px' }}
            />
            <div className={`p-3 flex flex-col justify-center`}>
              <div className={`flex flex-row items-center`}>
                <div className={`font-bold text-bluegray-700 text-sm mr-2`}>
                  {title}
                </div>
                {isRecommendMark && (
                  <div
                    className={`text-xs px-3 text-white bg-tradewell rounded-full`}>
                    オススメ
                  </div>
                )}
              </div>
              {description && roughTargetAmount && (
                <>
                  <div className={`mt-1 flex flex-row items-center`}>
                    <div className={`text-bluegray-500 text-xs mr-auto `}>
                      {description}
                    </div>
                    <div className={`text-bluegray-700 text-xs`}>
                      目安
                      {(num => {
                        const unit = getUnit(num);
                        return `${commaFormat(floorByUnit(num, unit))}${unit}`;
                      })(roughTargetAmount)}
                      円
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
          {recommendAccounts && (
            <div className={`border-t border-bluegrayslate-200 p-3`}>
              <div className={`font-bold text-xs text-bluegray-500`}>
                こんな口座を持っている人がよく立てている目標です
              </div>
              <div className={`flex flex-row gap-2 mt-1`}>
                {recommendAccounts.map((account, i) => {
                  return <RecommendAccountTag key={i} title={account} />;
                })}
              </div>
            </div>
          )}
        </div>
        <div
          className={`px-1 justify-center items-center flex flex-row bg-bluegray-50 border-l border-bluegray-100 rounded-r-lg`}>
          <div className="icon-chevron-right text-bluegray-400 font-bold flex flex-row"></div>
        </div>
      </div>
    </>
  );
};
